import { Controller } from "@hotwired/stimulus";

// License review page: toggles the License Owner block between a read-only
// summary and an inline, prefilled address form. The address fields are always
// in the DOM (just hidden) so they submit together with the acceptance checkbox.
export default class extends Controller {
  static targets = ["display", "fields"];
  static values = { open: Boolean };

  connect() {
    // Auto-expand when the server re-rendered with address validation errors.
    if (this.openValue) this.open();
  }

  edit(event) {
    event.preventDefault();
    this.open();
  }

  open() {
    this.displayTarget.classList.add("hidden");
    this.fieldsTarget.classList.remove("hidden");
  }
}
